module.exports = __webpack_public_path__ + "static/index/img/baikal-110.1e9cff8d.jpg";